<template>
  <div class="d-flex search-container mt-3">
    <v-col cols="4">
      <naj-input
        class="search-box"
        :outlined="false"
        :type-id="typeId"
        :placeholder="placeholder"
        @keyup.native.enter="$emit('filterDataClicked')"
        @input="onInput"
      >
        <template slot="prepend-inner">
          <v-icon
            class="icon"
            color="#02363d"
            @click="$emit('filterDataClicked')"
          >
            mdi-magnify
          </v-icon>
        </template>
      </naj-input>
    </v-col>
    <v-col cols="4">
    </v-col>
    <v-col
      cols="4"
      class="align-self-center pl-6"
    >
      <div
        class="filter-box d-flex"
        @click="$emit('showFilterClicked')"
      >
        <v-icon
          class="icon"
          color="#02363d"
        >
          mdi-filter-outline
        </v-icon>
        <span>{{ local.common.filter }}</span>
      </div>
    </v-col>
  </div>
</template>

<script>

export default {
  name: 'NajSearchBox',
  props: {
    typeId: {
      type: Number,
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: true,
      default: null,
    },
  },
  methods: {
    onInput(value) {
      this.$emit('update:search', value);
    },
  },

};
</script>

<style lang="scss" scoped>
.search-container {
  background-color: var(--app-light-secondary-color);
}
.search-box {
  ::v-deep .v-input.v-text-field--outlined fieldset {
    border-width: 0 !important;
  }
  ::v-deep .v-input.v-text-field--outlined {
    margin-top: 0 !important;
    .v-input__slot {
      margin-bottom: 0px;
      fieldset {
        background-color: var(--app-light-secondary-color);
      }
    }
    .v-text-field__details {
      display: none;
    }
  }
}

.filter-box {
  justify-content: end;
  cursor: pointer;
  color: #02363d;
  font-size: 16px;
  font-weight: bold;
}

::v-deep .search-box input {
  text-align: right;
}
</style>
